module.exports = __webpack_public_path__ + "img/asian-soup-1.7cd06dff.jpg";